"use client";
import React from "react";
import AppContext, { Zone } from "@/contexts/app-context";

export default function AppProvider({ children }: { children: React.ReactNode }) {
  const [zone, setZone] = React.useState<Zone>("dashboard");
  const [lastRoute, setLastRoute] = React.useState<string | null>(null);

  const value = React.useMemo(() => ({ zone, setZone, lastRoute, setLastRoute }), [zone, lastRoute]);
  return <AppContext.Provider value={value}>{children}</AppContext.Provider>;
}
